import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import moment from 'moment-timezone';
import DatePicker from "../../components/datePicker";

import { getSlots, getCenterPerSubject, getAvailability, updateAvailability, initiatePayment, getAllSubjects, addWaitlist } from "./api";
import { loaderEnd, loaderStart } from '../../components/loader';
import { useSelector } from "react-redux";


const Legend = (props) => {
    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: 10, height: 10, backgroundColor: props.color }}></div>
            &nbsp;{props.title}
        </div>
    )
}

const ApplyModal = (props) => {
    const [state, setState] = useState({
        slot_id: null,
        date: "",
        center_id: "",
    })
    const auth = useSelector(state => state.Auth?.auth?.data)
    const [activeDate, setActiveDate] = useState(null)
    const [allSlot, setAllSlot] = useState([]);
    const firstActiveDate = activeDate?.length
        ? new Date(Math.min(...activeDate.map((d) => new Date(d).getTime())))
        : null;
    const activeDateSet = new Set(
        (activeDate || []).map((date) => moment(date).format("YYYY-MM-DD"))
    );
    const [allCenter, setAllCenter] = useState([]);
    const navigate = useNavigate();
    const [waitlistForm, setWaitlistForm] = useState(false);
    const [isSundayBlocked, setIsSundayBlocked] = useState(false);
    // const [allHighlight, setAllHighlight] = useState([])
    console.log(auth);
    

    const [waitlistState, setWaitlistState] = useState({
        date: "",
        slot: ""
    })

    const updateData = (e, name) => {
        // console.log(name);
        let _state = { ...state }
        if (name === "center_id") {
            _state["date"] = "";
        }

        if (name === "date") {
            _state[name] = e;
        }
        else
            _state[e.target.name] = e.target.value;
        // console.log(_state);
        setState(_state);
    }

    useEffect(() => {
        const _ = async () => {
            let res = await getCenterPerSubject(props.data?.subject_code);
            if (res.code) {
                setAllCenter(res.data)
            }
        }
        _()
    }, [props.data?.subject_code])

    useEffect(() => {
        if (state.center_id) {
            getAvail();
        }
        setWaitlistForm(false)
    }, [state.center_id])

    const getAvail = async () => {
        loaderStart()
        let res = await getAvailability(state.center_id)
        // console.log(res);
        if (res.code) {
            let _date = res.data.map((r) => {
                let _d = moment(r.date).tz("Asia/Kolkata").format();
                _d = new Date(_d);
                return _d
            })
            console.log(_date);
            if (_date.length > 0)
                setActiveDate(_date)
            else
                setWaitlistForm(true)

        }
        else {
            setActiveDate([])
            setAllSlot([])
            setWaitlistForm(true)
        }
        loaderEnd()
    }

    useEffect(() => {
        if (state.center_id && state.date && !isSundayBlocked && isActiveExamDateValue(state.date)) {
            getSlotsData();
        }
    }, [state.center_id, state.date, isSundayBlocked])

    const getSlotsData = async () => {
        let res = await getSlots(state.center_id, 0, state.date)
        if (res.code) {
            setAllSlot(res.data)
        }
        else {
            setAllSlot([])
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (isSundayBlocked) {
            swal("Sunday is not allowed", "", "error")
            return
        }
        if (waitlistForm) {
            finalSubmitWaitlist()
        }
        else {
            if (state.date && state.center_id) {
                finalSubmit()
            }
            else {
                swal("Please select date, center and slot to proceed", "", "error")
            }
        }
    }

    const getSlot = (id) => {
        let filter = allSlot.filter((a) => a.id == id);
        // console.log(allSlot, filter, id);
        if (filter.length) {
            return filter[0].start_time + " - " + filter[0].end_time
        }
    }

    const isActiveExamDateValue = (dateValue) => {
        return activeDateSet.has(moment(dateValue).format("YYYY-MM-DD"));
    }

    const isActiveExamDate = (date) => {
        return activeDateSet.has(moment(date).format("YYYY-MM-DD"));
    }

    const getExamDayClassName = (date) => {
        if (!firstActiveDate || date < firstActiveDate) return "";
        return isActiveExamDate(date) ? "exam-date-available" : "exam-date-full";
    }

    const handleExamDateChange = (name, value) => {
        updateData(value, name);
        const selectedDate = moment(value).format("YYYY-MM-DD");
        const isSunday = moment(value).day() === 0;
        const isActiveDate = isActiveExamDateValue(value);

        setState((prev) => ({ ...prev, slot_id: null }));
        setAllSlot([]);

        if (isSunday) {
            setIsSundayBlocked(true);
            setWaitlistForm(false);
            swal("Sunday is not allowed", "", "error")
            return;
        }

        setIsSundayBlocked(false);

        if (isActiveDate) {
            setWaitlistForm(false);
        } else {
            setWaitlistForm(true);
            setWaitlistState((prev) => ({ ...prev, date: selectedDate }));
        }
    }

    const finalSubmit = async () => {
        // loaderStart()

        let data = {
            "center_id": state.center_id,
            "slot_id": state.slot_id,
            date: state.date,
            "with_training": "NO",
            subject_code: props.data.subject_code
        }
        // console.log(data);
        let res = await updateAvailability(data)
        // console.log(res);
        if (res.code == 1) {
            // showAlert(res.data)
            if (res.data.paymentStatus) {
                makePayment(res.data.allotmentId)
            }
            else {
                navigate("/payment-response/" + res.data.allotmentId)
            }
        }
        else {
            swal(res.message, "", "error")
        }

        loaderEnd()
    }

    const finalSubmitWaitlist = async () => {
        loaderStart()
        let data = {
            "user_id": auth.user_id,
            date: waitlistState.date,
            subject_code: props.data.subject_code,
            centre_id: state.center_id,
            slot_id: parseInt(waitlistState.slot)
        }
        let res = await addWaitlist(data)
        if (res.code == 1) {
            swal("Your waitlist date and slot is submitted.", "", "success")
            props.toggle()
        }
        else {
            swal(res.message, "", "error")
        }
        loaderEnd()
    }

    const showAlert = (allotmentId) => {
        swal("Slot Booking Submitted Successfully", "", "success")
            .then((value) => {
                // navigate('/payment')
                makePayment(allotmentId)
            });
    }

    const makePayment = async (allotmentId) => {
        loaderStart()
        let id = Math.floor(Date.now());
        let amt = state.category == 1 ? 350000 : 110000
        window.location.href = process.env.REACT_APP_API_URL + "form/payment?amount=" + amt + "&hdnOrderID=" + id + "&trnRemarks=&allotmentId=" + allotmentId
        loaderEnd()
    }

    // console.log(state);

    return (
        <form className="ui_modal_form" onSubmit={handleSubmit}>
            <div id="applications" className='ui_modal_body'>
                <div className="row  mt-3">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Please Select Center</label>
                    <div className="col-sm-6">
                        <select
                            className="form-select"
                            id="autoSizingSelect"
                            name={"center_id"}
                            required
                            value={state.center_id}
                            onChange={(e) => updateData(e, 'center_id')}
                        >
                            <option value=''>Select Center</option>
                            {
                                allCenter?.map((a) => (
                                    <option value={a.id}>{a.centre}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
                {
                    state.center_id && activeDate?.length > 0 &&
                    <>
                        <div className="row  mt-3">
                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Please Select Your Examination Date</label>
                            <div className="col-sm-6">
                                <DatePicker
                                    name={"date"}
                                    date={state.date ? new Date(state.date) : ""}
                                    required={false}
                                    handleDateChange={(name, e) => handleExamDateChange(name, e)}
                                    // excludeDates={disableDay}
                                    // maxDate={activeDate ? new Date(activeDate) : null}
                                    // minDate={new Date("2023-01-16")}
                                    // minDate={activeDate ? new Date(activeDate) : null}
                                    minDate={firstActiveDate}
                                    dayClassName={getExamDayClassName}
                                />
                                {/* <input type="date" className="form-control" id="inputEmail3" /> */}
                            </div>
                        </div>
                        {
                            !waitlistForm &&
                            <>
                                <div className="row  mt-3">
                                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Please Select Your Examination Slot</label>
                                    <div className="col-sm-6">
                                        <select
                                            className="form-select"
                                            id="autoSizingSelect"
                                            name={"slot_id"}
                                            required={!isSundayBlocked}
                                            disabled={isSundayBlocked}
                                            value={state.slot_id ? state.slot_id : ''}
                                            onChange={(e) => updateData(e)}
                                        >
                                            <option value=''>Select Slot</option>
                                            {
                                                allSlot?.map((a) => (
                                                    <option value={a.id}>{a.start_time} - {a.end_time}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="legend-section">
                                    <Legend color="green" title="Available" />
                                    <Legend color="red" title="Full" />
                                </div>
                                <div className="d-grid gap-2">
                                    <button className="btn btn-primary" type="submit" disabled={isSundayBlocked}><i className="fa fa-next"></i>&nbsp;Submit and Pay Now</button>
                                </div>
                            </>
                        }
                    </>
                }
                {
                    waitlistForm &&
                    <>
                        {/* Waitlist section */}
                        <p className="ui_modal_notice">
                            <i className="fa fa-info-circle" aria-hidden="true"></i>
                            {activeDate?.length > 0
                                ? "This date is full. Fill in the waitlist form and we will contact you if a seat opens."
                                : "No slots are available right now. Fill in the waitlist form and we will contact you if a seat opens."}
                        </p>
                        <div className="row  mt-3">
                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Suggested date</label>
                            <div className="col-sm-6">
                                <input
                                    className="form-select"
                                    id="autoSizingSelect"
                                    name={"date"}
                                    required
                                    type="date"
                                    value={waitlistState.date}
                                    onChange={(e) => {
                                        setWaitlistState({...waitlistState, date:e.target.value})
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row  mt-3">
                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"><i style={{ color: 'red', fontSize: '18px' }}>*&nbsp;</i>Suggested Slot</label>
                            <div className="col-sm-6">
                                <select
                                    className="form-select"
                                    id="autoSizingSelect"
                                    name={"slot"}
                                    required
                                    value={waitlistState.slot}
                                    onChange={(e) => {
                                        setWaitlistState({...waitlistState, slot:e.target.value})
                                    }}
                                >
                                    <option value=''>Select Slot</option>
                                    <option value="1">Slot 1</option>
                                    <option value="2">Slot 2</option>
                                </select>
                            </div>
                        </div>
                        <div className="d-grid gap-2">
                            <button className="ui_btn ui_btn_primary ui_btn_block" type="submit">Submit waitlist form</button>
                        </div>
                    </>
                }

            </div>

        </form>
    )
}

export default ApplyModal;
